import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from '../UserState';

/**
 * @deprecated Use UserProfileService.user$ instead
 */
export const selectUserLogged = createSelector(
  createFeatureSelector('login'),
  (state: UserState) => state
);
